module.exports = __webpack_public_path__ + "static/media/iconOne.3ede0bf2.svg";